// extracted by mini-css-extract-plugin
module.exports = {"BackupColumns":"BackupColumns_R-Yli","BackupColumnsLast":"BackupColumnsLast_fjtVx"};